/**
 * Identifiant de build injecté à la compilation (voir `vite.config.ts`).
 * Sert de clé de cache-busting : dès que le serveur annonce un identifiant
 * différent de celui embarqué dans le bundle chargé, le client recharge la
 * page pour récupérer le nouveau manifeste (plus jamais de chunk périmé).
 */
declare const __BUILD_VERSION__: string | undefined;

export const BUILD_VERSION: string =
  typeof __BUILD_VERSION__ === "string" && __BUILD_VERSION__.length > 0
    ? __BUILD_VERSION__
    : "dev";
